export default __webpack_public_path__ + "static/media/calendar.23bd3e9d.svg";